import { Outlet } from "react-router-dom";

import Header from "../../components/ui/Header/Header";
import Footer from "../../components/ui/Footer/Footer";
import ScrollToHashElement from "../../components/ui/ScrollToHashElement/ScrollToHashElement";

const MainLayout = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <ScrollToHashElement />
      <Header />
      <div className="flex-1">
        <Outlet />
      </div>
      <Footer />
    </div>
  );
};

export default MainLayout;
